import { makeBaseImagePath } from 'modules/app';

export function getInvoiceLink(invoice: Invoice) {
  return makeBaseImagePath(
    invoice.language === 'HR'
      ? invoice.invoiceFilenameHr
      : invoice.invoiceFilename,
  );
}
